import { isLocal } from '@/utils/axleEnvironment';
import { datadogRum } from '@datadog/browser-rum';
import { captureException, captureMessage } from '@sentry/react';
import { ErrorInfo } from 'react';

type ErrorContext = ErrorInfo & {
    isGlobal?: boolean;
};

export const reportError = (error: unknown, errorContext?: ErrorContext) => {
    if (isLocal) {
        // eslint-disable-next-line no-console
        console.error(error, errorContext);
    }
    captureException(error, { data: errorContext });
    datadogRum.addError(error, errorContext);
};

export const logMessage = (message: string) => {
    captureMessage(message);
    datadogRum.addAction(message);
};
